import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import DeliveryTabs from './DeliveryTabs'
import SectionButton from './SectionButton'

const OrderBar: FC = () => {
    return (
        <View style={styles.tabsContainer}>
            <DeliveryTabs />
            <SectionButton />
        </View>
    )
}

const styles = StyleSheet.create({
    tabsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: 60,
    },
})

export default OrderBar
